import { Environment } from '@src/enum/environment';
import companyRoutes from '@src/routes/company.tsx';
import sharedRoutes from '@src/routes/shared.tsx';
import tenantRoutes from '@src/routes/tenant.tsx';
import { matchRoutes } from 'react-router-dom';

export type Meta = {
  title: string;
  description: string;
  image: string;
  url: string;
  baseUrl: string;
  portalName: string;
  googleSearchSiteName: string;
};

const staticMeta = (path: string): Meta => {
  const env = import.meta.env.VITE_ENV === Environment.PRODUCTION ? '' : import.meta.env.VITE_ENV;
  const portalName: string = import.meta.env.VITE_APP_PORTAL_NAME ?? '';
  const googleSearchSiteName: string = import.meta.env.VITE_GOOGLE_SEARCH_SITE_NAME ?? '';
  const owner: string = import.meta.env.VITE_TITLE_SUFFIX ?? '';
  const baseUrl = import.meta.env.VITE_APP_BASE_URL;
  const route = matchRoute(path);

  const pageTitle = route?.title ?? '';
  const description = route?.description ?? '';

  function matchRoute(path: string) {
    const matches = routeMatches(path);
    if (!matches) {
      return null;
    }
    return matches[matches.length - 1]?.route;
  }

  function routeMatches(path: string) {
    return (
      matchRoutes(companyRoutes, path) ??
      matchRoutes(sharedRoutes, path) ??
      matchRoutes(tenantRoutes, path)
    );
  }

  return {
    title:
      env + (pageTitle ? pageTitle + '|' + portalName + '|' + owner : portalName + '|' + owner),
    description: description,
    image: baseUrl + '/ogp.png',
    url: description ? baseUrl + path : baseUrl,
    baseUrl: baseUrl,
    portalName: portalName,
    googleSearchSiteName: googleSearchSiteName,
  };
};

const formatTitle = (title: string): string => {
  const env = import.meta.env.VITE_ENV === Environment.PRODUCTION ? '' : import.meta.env.VITE_ENV;
  const portalName: string = import.meta.env.VITE_APP_PORTAL_NAME ?? '';
  const owner: string = import.meta.env.VITE_TITLE_SUFFIX ?? '';

  return env + (title ? title + '|' + portalName + '|' + owner : portalName + '|' + owner);
};

export { formatTitle, staticMeta };
